import React from 'react';

interface CheckCircleIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function CheckCircleIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<CheckCircleIconProps>) {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.8013 9.42078C17.1083 9.04931 17.0535 8.50141 16.6788 8.19701C16.3041 7.89261 15.7514 7.94697 15.4443 8.31844L10.8727 13.8488L8.48712 11.5609C8.13894 11.227 7.58361 11.2361 7.24676 11.5813C6.9099 11.9264 6.91908 12.4769 7.26726 12.8109L10.3374 15.7554C10.5136 15.9244 10.7532 16.0126 10.998 15.9986C11.2427 15.9845 11.4704 15.8696 11.6258 15.6816L16.8013 9.42078Z"
				fill={fill}
			/>
		</svg>
	);
}
